import React from 'react';
import ReactDOM from 'react-dom';
import {combineReducers} from 'redux';
import {Provider} from 'react-redux';

import OrdersUpdateButtonConnector from 'components/OrdersUpdateButton';
import configureStore from 'store';
import orders from 'ducks/orders';


function initOrdersUpdateButton() {
    const elem = document.getElementById('orders-update-button');
    if (!elem) {
        console.error("initOrdersUpdateButton() called but no #orders-update-button present!");
        return;
    }

    // Create Redux store
    const rootReducer = combineReducers({
        orders,
    });
    const store = configureStore(rootReducer);

    ReactDOM.render(
        <Provider store={store}>
            <OrdersUpdateButtonConnector />
        </Provider>,
        elem,
    );
}


export default initOrdersUpdateButton;



// WEBPACK FOOTER //
// ./src/views/OrdersUpdateButton.js